import { isNumeric } from "Utilities/numberHelpers";
import initialMockSettingsData from "./utilities/initialMockSettingsData";

const updateSetting = (postData) => {
  const { setting, value, itemID, action } = postData;

  let newSettings = { ...initialMockSettingsData };
  let success = true;

  switch (setting) {
    case "networkFamilyRegistration": {
      newSettings[setting].enabled = value;
      break;
    }

    case "introductionMessage": {
      if (typeof value === "boolean") newSettings[setting].enabled = value;
      else if (typeof value === "string") newSettings[setting].message = value;
      break;
    }

    case "accentColor": {
      newSettings[setting].selectedColor = value;
      break;
    }

    case "membershipStatus": {
      if (itemID) {
        // const status = newSettings[setting].statuses.find(s => s.membershipItemID === itemID);
        const status = newSettings[setting].statuses.find(
          (item) => item.membershipStatusID === itemID
        );
        // newSettings[setting].statuses[itemID -1].enabled = value; ?

        switch (action) {
          case "toggle":
            status.enabled = value;
            break;
          case "rename":
            status.description = value;
            break;
          case "reorder":
            status.order += value;

            newSettings[setting].statuses.forEach((item, i) => {
              if (item.membershipStatusID === itemID) return;

              if (value > 0 && item.order <= status.order && i > 0) {
                item.order -= 1;
              }

              if (
                value < 0 &&
                item.order >= status.order &&
                i < newSettings[setting].statuses.length - 1
              ) {
                item.order += 1;
              }
            });

            newSettings[setting].statuses.sort((a, b) => {
              return a.order - b.order;
            });
            break;
          case "delete":
            newSettings[setting].statuses = newSettings[
              setting
            ].statuses.filter((s) => s.membershipStatusID !== itemID);
            break;
          // case "create":
          //   newSettings.statuses.push({
          //     enabled: true,
          //     membershipStatusID: newSettings.statuses.length,
          //     description: value,
          //     order: newSettings.statuses.length,
          //     canEditDescription: true,
          //     canReorder: true,
          //     canDelete: true,
          //   });
          //   break;
          default:
            success = false;
            break;
        }

        // // Case: Enable/Disable Status
        // if (typeof value === "boolean") status.enabled = value;
        // // Case: Edit Name
        // else if (action === "rename" && typeof value === "string") status.description = value;
        // // Case: Reorder
        // else if (isNumeric(value)) {
        //   status.order += value;
        // }
      } else {
        switch (action) {
          case "toggle":
            newSettings[setting].enabled = value;
            break;
          case "create": {
            let length = newSettings[setting].statuses.length;
            // update deceased to have a higher order
            newSettings[setting].statuses[length - 1].order = length + 1;

            // add new status
            newSettings[setting].statuses.push({
              enabled: true,
              membershipStatusID: length,
              description: value,
              order: length,
              canEditDescription: true,
              canReorder: true,
              canDelete: true,
            });

            newSettings[setting].statuses.sort((a, b) => {
              return a.order - b.order;
            });

            break;
          }
          default:
            success = false;
            break;
        }

        // Case: Enable/Disable Entire Setting
        // if (typeof value === "boolean") newSettings[setting].enabled = value;
        // // Case: Create New Setting
        // else if (typeof value === "string") newSettings.statuses.push({
        //     enabled: true,
        //     membershipStatusID: newSettings.statuses.length,
        //     description: value,
        //     order: newSettings.statuses.length,
        //     canEditDescription: true,
        //     canReorder: true,
        //     canDelete: true,
        // });
      }
      break;
    }

    case "extendedFieldsAdults": {
      if (itemID) {
        const field = newSettings[setting].statuses[itemID - 1];
        if (action === "toggle") field.enabled = value;
        else if (action === "reorder") {
          field.order += value;
          newSettings[setting].fields.sort((a, b) => a.order - b.order);
        }
      } else {
        newSettings[setting].enabled = value;
      }
      break;
    }

    case "registrationGroupAdults": {
      if (itemID) {
        newSettings[setting].selectedGroupID = value;
      } else {
        newSettings[setting].enabled = value;
      }
      break;
    }

    case "extendedFieldsChildren": {
      if (itemID) {
        const field = newSettings[setting].statuses[itemID - 1];
        if (action === "toggle") field.enabled = value;
        else if (action === "reorder") {
          field.order += value;
          newSettings[setting].fields.sort((a, b) => a.order - b.order);
        }
      } else {
        newSettings[setting].enabled = value;
      }
      break;
    }

    case "registrationGroupChildren": {
      if (itemID) {
        newSettings[setting].selectedGroupID = itemID;
      } else {
        newSettings[setting].enabled = value;
      }
      break;
    }

    case "recurringGifts": {
      if (itemID) {
        newSettings[setting].selectedFundID = itemID;
      } else {
        newSettings[setting].enabled = value;
      }
      break;
    }

    case "receiveGivingEnvelopes": {
      newSettings[setting].enabled = value;
      break;
    }

    case "closingMessage": {
      if (typeof value === "boolean") newSettings[setting].enabled = value;
      else if (typeof value === "string") newSettings[setting].message = value;
      break;
    }

    case "finishedActionClosing": {
      newSettings[setting].enabled = value;
      newSettings.finishedActionSignup.enabled = false;
      newSettings.finishedActionWebsite.enabled = false;
      break;
    }

    case "finishedActionSignup": {
      if (itemID) {
        newSettings[setting].selectedSignupID = itemID;
        newSettings[setting].enabled = true;
        newSettings.finishedActionClosing.enabled = false;
        newSettings.finishedActionWebsite.enabled = false;
      } else {
        newSettings[setting].enabled = value;
        newSettings.finishedActionClosing.enabled = false;
        newSettings.finishedActionWebsite.enabled = false;
      }
      break;
    }

    case "finishedActionWebsite": {
      if (typeof value === "boolean") {
        newSettings[setting].enabled = value;
        newSettings.finishedActionClosing.enabled = false;
        newSettings.finishedActionSignup.enabled = false;
      } else if (typeof value === "string") {
        newSettings[setting].websiteUrl = value;
        newSettings[setting].enabled = true;
        newSettings.finishedActionClosing.enabled = false;
        newSettings.finishedActionSignup.enabled = false;
      }
      break;
    }

    case "completionNote": {
      if (itemID) newSettings[setting].selectedUserID = itemID;
      else newSettings[setting].enabled = value;
      break;
    }

    default:
      break;
  }

  // let success = (setting?.length && (value || itemID) || false)

  let resp = {
    isApp: false,
    success,
    familyRegistrationSettings: newSettings,
  };

  return resp;
};

export default updateSetting;